"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PuppetRatingRequest = void 0;
var React = require("react");
var PuppetRatingRequest = /** @class */ (function (_super) {
    __extends(PuppetRatingRequest, _super);
    function PuppetRatingRequest(props) {
        var _this = _super.call(this, props) || this;
        _this.queryRating = _this.queryRating.bind(_this);
        return _this;
    }
    PuppetRatingRequest.prototype.componentDidMount = function () {
        this.queryRating();
    };
    PuppetRatingRequest.prototype.componentWillUnmount = function () {
        if (this.queryTimeout)
            clearTimeout(this.queryTimeout);
    };
    PuppetRatingRequest.prototype.queryRating = function () {
        var _this = this;
        if (this.queryTimeout)
            clearTimeout(this.queryTimeout);
        if (!this.props)
            return;
        if (this.props.ratings)
            return;
        if (this.props.connectedClient)
            this.props.requestTaskRating(this.props.connectedClient.sessionGuid);
        this.queryTimeout = setTimeout(function () { _this.queryRating(); }, 2000);
    };
    PuppetRatingRequest.prototype.render = function () {
        if (!this.props)
            return null;
        if (this.props.ratings)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "d-flex flex-row text-center justify-content-center" },
                React.createElement("div", { className: "spinner-grow text-secondary" }),
                React.createElement("div", { className: "lead" }, "Waiting for rating"))));
    };
    ;
    return PuppetRatingRequest;
}(React.PureComponent));
exports.PuppetRatingRequest = PuppetRatingRequest;
//# sourceMappingURL=PuppetRatingRequest.js.map